import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import "./menubar.script";
export function RuiMenubar({
  items,
  label,
  children,
  ...props
}) {
  const content = items != null ? items.map(item => /* @__PURE__ */jsxs("div", {
    class: "rui-menubar__root",
    "data-ref": "menubar-root",
    children: [/* @__PURE__ */jsx("button", {
      type: "button",
      class: "rui-menubar__item",
      role: "menuitem",
      tabindex: -1,
      "aria-haspopup": item.items?.length ? "true" : void 0,
      "aria-expanded": item.items?.length ? "false" : void 0,
      children: item.label
    }), item.items?.length ? /* @__PURE__ */jsx("div", {
      class: "rui-menubar__menu rui-popover rui-floating",
      role: "menu",
      hidden: true,
      children: item.items.map(child => /* @__PURE__ */jsx("button", {
        type: "button",
        class: "rui-menubar__menu-item",
        role: "menuitem",
        "data-value": child.id,
        tabindex: -1,
        children: child.label
      }))
    }) : null]
  })) : children;
  return /* @__PURE__ */jsx("rui-menubar", {
    ...props,
    label,
    children: /* @__PURE__ */jsx("div", {
      class: "rui-menubar",
      "data-ref": "root",
      role: "menubar",
      "aria-label": label || void 0,
      children: content
    })
  });
}